import React from 'react';
import App from './App.jsx';
import ReactDOM from 'react-dom';

ReactDOM.render(
  <App />, 
  document.querySelector('#root')
);
